import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Dashboard Error Boundary caught an error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="alert alert-danger d-flex align-items-center">
          <i className="fas fa-exclamation-triangle me-3"></i>
          <div>
            <h6 className="mb-1">Error al cargar los datos del dashboard</h6>
            <small>Por favor, recarga la página o contacta al administrador si el problema persiste.</small>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export { ErrorBoundary };
